export type Node<T> = {
  id: string;
  data: T;
  parent: string;
  indexWithinParent: number;
  prev: string;
  next: string;
};
type PrepareNode<T> = {
  id: string;
  data: T;
  parent?: string;
  index: number;
  prev?: string;
  next?: string;
};
export const createNode = <T>({ id, data, parent, prev, next, index }: PrepareNode<T>): Node<T> => {
  const node = Object.create(null);

  node.id = id;
  node.data = data;
  node.parent = parent;
  node.indexWithinParent = index;
  node.prev = prev;
  node.next = next;

  return node;
};
